const astronomyText = `¿Qué es la Astronomía?
La astronomía estudia todo lo que está fuera del planeta Tierra y también algunas cosas dentro de este. Es como una gran historia de detectives que buscan resolver los misterios del universo, desde su formación hasta su posible extinción, pasando por cada objeto como las estrellas, los planetas y los cometas, e incluso las vastas galaxias como en la que vivimos o las muy, muy lejanas. La astronomía nos ayuda a entender qué hay ahí fuera, de dónde viene, cómo se comporta o cambia y que podría pasar en el futuro. ¿Y saben qué? No necesitas ser un adulto para empezar a explorar el universo. ¡Incluso los niños como tú pueden convertirse en detectives del cosmos!

El Cielo Nocturno
¿Alguna vez has mirado al cielo despejado en la noche y te has preguntado acerca de las pequeñas luces que brillan arriba? ¡La mayoría de esas luces son estrellas, hay millones de ellas, aunque nuestros ojos ven solo algunas miles! En la noche también puedes ver la Luna, algunos planetas que serían como nuestros vecinos cósmicos, y satélites artificiales que se mueven alrededor de nuestro planeta, entre otros objetos. El cielo nocturno ya no es solo una manta gigante y oscura, ahora es como un mapa del tesoro lleno de maravillas esperando ser descubiertas.

La Historia de Cómo José G Se Interesó en la Astronomía

Déjenme contarles un pequeño secreto sobre cómo me enamoré de las estrellas. Cuando tenía su edad, solía ir al campo a pasar vacaciones a la casa de mis abuelos maternos, ellos vivían en un lugar alejado de la ciudad. En las noches salía a observar el cielo porque las estrellas se veían increíbles, yo imaginaba cientos de historias y me surgian muchas dudas sobre todo lo que observaba allí. Fue entonces cuando supe que quería aprender más sobre estos maravillosos puntos brillantes, algunos que permanecían quietos y otros que se movían. Así que, pónganse sus sombreros de detectives y exploremos juntos los misterios del universo.

¿Qué necesitamos para empezar?
"Para empezar el viaje necesitamos nuestros ojos, un poco de curiosidad y un sentido de aventura. También puedes usar binoculares que ayudarían a ver las estrellas con mayor
claridad y si realmente te apasiona, un telescopio te dejaría ver más detalles de la Luna y los planetas más cercanos a la Tierra. Sin embargo, lo más importante para empezar este viaje es reconocer a simple vista algunos objetos en el cielo, aun no te apresures con
equipos sofisticados. ¿Estás listo para ver el universo con nuevos ojos? ¡Adelante!

El Viaje que Nos Espera
En los próximos capítulos, aprenderemos sobre el Sol, la Luna, los planetas, las estrellas y algunas constelaciones que iluminan el cielo nocturno de Colombia. Intentaremos desentrañar los secretos del universo, una estrella a la vez. Así que preparen el traje espacial jóvenes, porque nuestro viaje a través del cosmos está apenas comenzando.

Antes de continuar, aquí tienes una pequeña actividad interesante para ti. Durante la noche, si el cielo está despejado, sal y observa hacia arriba. ¿Puedes encontrar la estrella más brillante del cielo? Esta podría ser Sirio de la constelación del Can Mayor, realmente son un par de estrellas que se encuentran cerca a la Tierra ¡pero no te asustes! que al decir cerca podrían ser millones de kilómetros, o también podría ser la estrella Arturo de la constelación del Boyero. Dependiendo de la fecha en que la te encuentres podría ser una de estas dos o quizás alguna otra muy brillante. Imaginalas guiándote, invitándote a explorar más. Mantén
tus ojos en el cielo amigo y recuerda cada estrella tiene un nombre y muchas historias que contar. ¡Hasta la próxima, sigue mirando arriba!`

const astronomyQuestions = [
  {
    question: "¿Qué estudia la astronomía?",
    options: [
      "Solo los planetas del sistema solar",
      "Todo lo que está fuera del planeta Tierra y algunas cosas dentro de este",
      "Únicamente las estrellas",
      "Solo la Luna y el Sol",
    ],
    correctAnswer: 1,
    explanation:
      "La astronomía estudia todo lo que está fuera del planeta Tierra y también algunas cosas dentro de este, desde estrellas hasta galaxias lejanas.",
  },
  {
    question: "¿Cuántas estrellas podemos ver a simple vista en el cielo nocturno?",
    options: [
      "Millones de estrellas",
      "Cientos de estrellas",
      "Solo algunas miles de estrellas",
      "Todas las estrellas del universo",
    ],
    correctAnswer: 2,
    explanation:
      "Aunque hay millones de estrellas en el cielo, nuestros ojos solo pueden ver algunas miles de ellas a simple vista.",
  },
  {
    question: "¿Dónde observaba José G las estrellas cuando era niño?",
    options: ["En la ciudad", "En el campo, en la casa de sus abuelos", "En un observatorio", "En la escuela"],
    correctAnswer: 1,
    explanation:
      "José G observaba las estrellas en el campo, en la casa de sus abuelos maternos, que vivían en un lugar alejado de la ciudad.",
  },
  {
    question: "¿Qué es lo más importante para empezar a explorar el universo según el texto?",
    options: [
      "Tener un telescopio muy costoso",
      "Nuestros ojos, curiosidad y sentido de aventura",
      "Ser un adulto",
      "Vivir cerca de un observatorio",
    ],
    correctAnswer: 1,
    explanation:
      "Para empezar el viaje necesitamos nuestros ojos, un poco de curiosidad y un sentido de aventura. No se necesitan equipos sofisticados al principio.",
  },
  {
    question: "¿Qué objetos podemos ver en el cielo nocturno además de las estrellas?",
    options: [
      "Solo la Luna",
      "La Luna, planetas y satélites artificiales",
      "Únicamente planetas",
      "Solo satélites artificiales",
    ],
    correctAnswer: 1,
    explanation:
      "En el cielo nocturno podemos ver la Luna, algunos planetas (vecinos cósmicos), satélites artificiales y otros objetos además de las estrellas.",
  },
  {
    question: "¿Cuál es una de las estrellas más brillantes que podemos encontrar en el cielo?",
    options: ["La Luna", "El Sol", "Sirio de la constelación del Can Mayor", "Venus"],
    correctAnswer: 2,
    explanation:
      "Sirio de la constelación del Can Mayor es una de las estrellas más brillantes que podemos observar en el cielo nocturno.",
  },
  {
    question: "¿Qué nos ayuda a entender la astronomía?",
    options: [
      "Solo cómo se forman las estrellas",
      "Qué hay en el universo, de dónde viene, cómo se comporta y qué podría pasar en el futuro",
      "Únicamente la historia de la Tierra",
      "Solo los planetas cercanos",
    ],
    correctAnswer: 1,
    explanation:
      "La astronomía nos ayuda a entender qué hay ahí fuera, de dónde viene, cómo se comporta o cambia y qué podría pasar en el futuro.",
  },
  {
    question: "¿Qué herramienta te ayudaría a ver más detalles de la Luna y los planetas cercanos?",
    options: ["Binoculares", "Un telescopio", "Una lupa", "Gafas de sol"],
    correctAnswer: 1,
    explanation:
      "Un telescopio te dejaría ver más detalles de la Luna y los planetas más cercanos a la Tierra, aunque no es necesario para empezar.",
  },
  {
    question: "¿Quiénes pueden convertirse en detectives del cosmos según el texto?",
    options: [
      "Solo los científicos adultos",
      "Solo las personas con telescopios",
      "Incluso los niños",
      "Solo los profesores",
    ],
    correctAnswer: 2,
    explanation:
      "El texto menciona que no necesitas ser un adulto para empezar a explorar el universo, incluso los niños pueden convertirse en detectives del cosmos.",
  },
  {
    question: "¿Qué temas aprenderemos en los próximos capítulos según el texto?",
    options: [
      "Solo sobre la Luna",
      "El Sol, la Luna, los planetas, las estrellas y constelaciones",
      "Únicamente sobre las galaxias",
      "Solo sobre los cometas",
    ],
    correctAnswer: 1,
    explanation:
      "En los próximos capítulos aprenderemos sobre el Sol, la Luna, los planetas, las estrellas y algunas constelaciones que iluminan el cielo nocturno de Colombia.",
  },
]

module.exports = {
  astronomyText,
  astronomyQuestions,
}
